export const AGENT_COOKIE = 'ta_agent';
export const AFFILIATE_COOKIE = 'ta_affiliate';

const MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

export const readTrackingCookie = (
  cookieHeader: string | undefined,
  name: string
): string => {
  if (!cookieHeader) return '';

  const entry = cookieHeader
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${name}=`));

  return entry ? decodeURIComponent(entry.slice(name.length + 1)) : '';
};

const writeCookie = (name: string, value: string) => {
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; path=/; max-age=${MAX_AGE_SECONDS}; samesite=lax`;
};

export const persistTrackingParams = (query: {
  agent?: string | string[];
  affiliate?: string | string[];
}) => {
  const single = (value?: string | string[]) =>
    Array.isArray(value) ? value[0] : value;

  const agent = single(query.agent);
  const affiliate = single(query.affiliate);

  if (agent) writeCookie(AGENT_COOKIE, agent);
  if (affiliate) writeCookie(AFFILIATE_COOKIE, affiliate);
};

export const forgetTrackingParams = () => {
  for (const name of [AGENT_COOKIE, AFFILIATE_COOKIE]) {
    document.cookie = `${name}=; path=/; max-age=0; samesite=lax`;
  }
};
